import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Label } from "reactstrap";
import { setShowcasePwd } from '../../../../../../slices/showcase/reducer';
import { handleSetPassword } from '../../../../../../slices/showcase/thunk';

function SecurityTab() {
  const dispatch = useDispatch();
  const [pwdState, setPwdState] = useState();

  function handleChange(e) {
    setPwdState(e.target.value);
  }


  return (
    <div>
      <Label className='mb-0' htmlFor='password'>
        Password
      </Label>
      <div className='w-100 d-flex align-items-center'>
        <input type="password" className='form-control' placeholder='Choose a password to protect your showcase' onChange={handleChange} />
        <button className='btn btn-primary ms-1' style={{ whiteSpace: "nowrap" }} onClick={() => dispatch(handleSetPassword(pwdState))}>
          Set Password
          <i className='ri-lock-2-line align-bottom ms-1'></i>
        </button>
      </div>
    </div>
  )
}

export default SecurityTab
